module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/point03-02bc5b3cf058557b1d37eb96b4065dbb.png";